import { render } from "./ActionButtonComponent.vue?vue&type=template&id=363b6e5d&scoped=true"
import script from "./ActionButtonComponent.vue?vue&type=script&lang=js"
export * from "./ActionButtonComponent.vue?vue&type=script&lang=js"

import "./ActionButtonComponent.vue?vue&type=style&index=0&id=363b6e5d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-363b6e5d"]])

export default __exports__